import { render, staticRenderFns } from "./KusBaseVideo.vue?vue&type=template&id=1969cb54"
import script from "./KusBaseVideo.vue?vue&type=script&lang=js"
export * from "./KusBaseVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports